export default {
    serverUrl: process.env.SERVER_URL,
    apiUrl: process.env.API_URL,
    adminUrl: process.env.ADMIN_URL,
    ieCORS: '/content/core/proxy.html',
    trainlineUrl: 'http://my.keytravel.com/Umbraco/Api/MemberApi/GoToTrainline',
    profileUrl: 'http://my.keytravel.com/Umbraco/Api/MemberApi/LoginWithToken',
    redirectToPageUrl: 'http://my.keytravel.com/Umbraco/Api/MemberApi/GoToPage',
    disableLocalization: false,
    filtersTimeout: 0,
    productSearchTimeout: 180000,
    googleAnalyticsTrackingCode: process.env.GOOGLE_ANALYTICS_TRACKING_CODE,
    googleApiKey: process.env.GOOGLE_API_KEY,
    logoutUrl: process.env.LOGOUT_URL,
    spreedlyKey: process.env.SPREEDLY_KEY,
};



// WEBPACK FOOTER //
// ./src/app/constants/app.constants.js